const translations = {
	en: {
		welcome: "Welcome",
		description: "This is a sample description.",
		work_process: "Work Process",
		mgnrega_flow: "MGNREGA Flow",
		workflow_description:
			"The workflow of the Mahatma Gandhi National Rural Employment Guarantee Act (MGNREGA) in Karnataka involves several steps from planning to implementation and monitoring. Here's an overview of the typical workflow",
		planning_budget_allocation: "Planning and Budget Allocation",
		planning_description:
			"The planning process begins at the Gram Panchayat level, where local development needs are identified. Gram Sabhas (village assemblies) play a crucial role in prioritizing projects and allocating funds under MGNREGA. Based on the proposals received from Gram Panchayats, the state government allocates budgets for MGNREGA activities.",
		job_demand_registration: "Job Demand Registration",
		job_demand_description:
			"Rural households in Karnataka can register their demand for employment under MGNREGA at the local Gram Panchayat office. The job demand registration includes details such as the number of days of employment required and the type of work preferred.",
		work_allocation: "Work Allocation",
		work_allocation_description:
			"After registering job demands, the Gram Panchayat authorities allocate work to eligible households based on the demand, availability of funds, and project priorities. The worksite and tasks are decided according to the local development needs and feasibility.",
		raise_new_demand: "Raise New Demand",
		actionplan_proceeding: "Action Plan Proceeding",
		actionplan_priority: "Action Plan Priority",
		gp_budget_data: "GP Budget Data",
		back_to_raise_new_demand: "Back to Raise New Demand", // Added
		raise_new_demand_with_another_account:
			"Raise New Demand with another account",
		go_to_pending_work_list: "Go to Pending Work List",
		public_verify_phone_number:
			"Please verify your phone number to raise a new demand",
		demand_request_accepted_message:
			"Your request has been accepted. Grama Panchayat representative will contact you soon.",
		next_step_choose_work: "Next Step (Choose work)",
		zilla_panchayat: "Zilla Panchayat",
		taluk_panchayat: "Taluk Panchayat",
		gram_panchayat: "Gram Panchayat",
		village: "Village",
		work_type: "Work Type",
		full_name: "Full Name",
		job_card: "Job Card",
		remarks: "Remarks",
		back: "Back",
		select: "Select",
		who_we_are: "Who We Are ?",
		our_story: "Our MGNREGA Story",
		about_description:
			"Directorate of MGNREGS was established on 2-4-2008, with the objective of effective implementation of Mahatma Gandhi National Rural Employment Scheme. Rural Development Commissionerate was created on 6-8-2013 to monitor the implementation of the scheme as per operational guidelines -2013 of the scheme. The post of Director was upgraded to 'Commissioner, Rural Development'. The Commissionerate is responsible for monitoring the implementation of Mahatma Gandhi National Rural Employment Scheme as well as other schemes assigned by the Government. Presently along with MGNREGS, Shyam Prasad Mukherjee Rurban Mission, Sansad Adarsh Gram Yojana and Unnati Schemes are being implemented under the supervision of the Commissionerate. Commissioner, Rural Development is the head of the Commissionerate. A Chief Operating Officer, four Joint Directors, a Chief Financial Adviser, four Assistant Directors, an Accountant, Audit officer and other supporting staff are working to assist the commisioner.",
		view_portfolio: "View Portfolio",
		portfolio: "Portfolio",
		our_schemes: "Our Schemes",
		portfolio_description: "Here are some of the schemes we are working on.",
		amruth_sarovara: "Amruth Sarovara",
		jaljeevan_mission: "Jal Jeevan Mission",
		jal_sanjeevini: "Jal Sanjeevini",
		grey_water_management: "Grey Water Management",
		convergence_comes_here: "Convergence Comes Here",
		what_is_convergence: "Convergence is the integration of various schemes.",
		get_started: "Get Started",
		//translations for Contact.js
		contact_us: "Contact Us",
		get_in_touch: "Get In Touch!",
		contact_description: "We are here to help.",
		name_placeholder: "Name :",
		email_placeholder: "Email :",
		subject_placeholder: "Subject :",
		message_placeholder: "Message :",
		send_message: "Send Message",
		phone_helpline: "Phone Helpline",
		commissioner: "Commissioner",
		email: "Email",
		location: "Location",
		phone_number: "Phone Number",
		send_otp: "Send OTP",
		otp_sent_message:
			"We've sent you a 6 digit code to the above mobile number. Please enter that here to sign in.",
		otp_sent_again_message:
			"OTP has been resent to your phone number. Please enter it below again",
		resend_otp: "Resend OTP",
		otp_expires_in: "OTP expires in",
		submit: "Submit",
		home: "Home",
		about_us: "About Us",
		services: "Services",
		sign_in: "Sign In",
		for: "For",
		days_to: "days to",
		individual: "Individual",
		community: "Community",
		want_a_job: "For Work Benefits",
		banner_title: "Providing Brilliant Ideas",
		banner_desc:
			"Wage employment in a financial year to every household. MGNREGA plays a crucial role in promoting inclusive growth, reducing rural distress, and building sustainable rural livelihoods in India. Daily wage 349rs",
		raise_request: "Raise request",
		recent_work_history: "Recent Work History",
		work_code: "Work Code",
		wage: "Wage",
		material: "Material",
		demand_sucsess: "Demand Raised Successfully",
		work_demand_code: "Work Demand Code",
		work_title: "Work Title",
		category_title: "Category Title",
		description_label: "Description",
		simplified_work_category: "Simplified Work Category",
		work_sub_type_1: "Work Sub-type I",
		work_sub_type_2: "Work Sub-type II",
		work_sub_type_3: "Work Sub-type III",
		work_sub_type_4: "Work Sub-type IV",
	},
	ka: {
		welcome: "ಸ್ವಾಗತ",
		description: "ಇದು ಮಾದರಿ ವಿವರಣೆ.",
		work_process: "ಕೆಲಸದ ಪ್ರಕ್ರಿಯೆ",
		mgnrega_flow: "MGNREGA ಕಾರ್ಯ ಪ್ರಕ್ರಿಯೆ",
		workflow_description:
			"ಮಹಾತ್ಮ ಗಾಂಧಿ ರಾಷ್ಟ್ರೀಯ ಗ್ರಾಮೀಣ ಉದ್ಯೋಗ ಖಾತರಿ ಕಾಯ್ದೆ (MGNREGA) ಯ ಕೆಲಸದ ಹಾದಿ ಕರ್ನಾಟಕದಲ್ಲಿ ಯೋಜನೆ, ಅನುಷ್ಠಾನ ಮತ್ತು ಮೇಲ್ವಿಚಾರಣೆಯ ವಿವಿಧ ಹಂತಗಳನ್ನು ಒಳಗೊಂಡಿದೆ. ಇಲ್ಲಿದೆ ಸಾಮಾನ್ಯ ಕೆಲಸದ ಹಾದಿಯ ಒಂದು ಅವಲೋಕನ",
		planning_budget_allocation: "ಯೋಜನೆ ಮತ್ತು ಬಜೆಟ್ ಹಂಚಿಕೆ",
		planning_description:
			"ಯೋಜನಾ ಪ್ರಕ್ರಿಯೆ ಗ್ರಾಮ ಪಂಚಾಯತ್ ಮಟ್ಟದಲ್ಲಿ ಪ್ರಾರಂಭವಾಗುತ್ತದೆ, ಅಲ್ಲಿ ಸ್ಥಳೀಯ ಅಭಿವೃದ್ಧಿ ಅಗತ್ಯಗಳನ್ನು ಗುರುತಿಸಲಾಗುತ್ತದೆ. ಗ್ರಾಮ ಸಭೆಗಳು (ಗ್ರಾಮ ಸಭೆಗಳು) MGNREGA ಅಡಿಯಲ್ಲಿ ಯೋಜನೆಗಳನ್ನು ಆದ್ಯತೆ ನೀಡುವಲ್ಲಿ ಮತ್ತು ನಿಧಿಗಳನ್ನು ಹಂಚಿಕೆಯಾಗುವಲ್ಲಿ ಪ್ರಮುಖ ಪಾತ್ರ ವಹಿಸುತ್ತವೆ. ಗ್ರಾಮ ಪಂಚಾಯತ್‌ಗಳಿಂದ ಬಂದ ಪ್ರಸ್ತಾವನೆಗಳ ಆಧಾರದ ಮೇಲೆ, ರಾಜ್ಯ ಸರ್ಕಾರ MGNREGA ಚಟುವಟಿಕೆಗಳಿಗೆ ಬಜೆಟ್‌ಗಳನ್ನು ಹಂಚುತ್ತದೆ.",
		job_demand_registration: "ಉದ್ಯೋಗ ಬೇಡಿಕೆ ನೋಂದಣಿ",
		job_demand_description:
			"ಕರ್ನಾಟಕದ ಗ್ರಾಮೀಣ ಮನೆಮಂದಿಗಳು ಸ್ಥಳೀಯ ಗ್ರಾಮ ಪಂಚಾಯತ್ ಕಚೇರಿಯಲ್ಲಿ MGNREGA ಅಡಿಯಲ್ಲಿ ಉದ್ಯೋಗದ ಬೇಡಿಕೆಯನ್ನು ನೋಂದಾಯಿಸಬಹುದು. ಉದ್ಯೋಗ ಬೇಡಿಕೆ ನೋಂದಣಿಯಲ್ಲಿ ಅಗತ್ಯವಿರುವ ಉದ್ಯೋಗದ ದಿನಗಳ ಸಂಖ್ಯೆ ಮತ್ತು ಇಚ್ಛಿತ ಕೆಲಸದ ಪ್ರಕಾರದ ವಿವರಗಳನ್ನು ಒಳಗೊಂಡಿರುತ್ತದೆ.",
		work_allocation: "ಕೆಲಸ ಹಂಚಿಕೆ",
		work_allocation_description:
			"ಉದ್ಯೋಗ ಬೇಡಿಕೆಗಳನ್ನು ನೋಂದಾಯಿಸಿದ ನಂತರ, ಗ್ರಾಮ ಪಂಚಾಯತ್ ಅಧಿಕಾರಿಗಳು ಬೇಡಿಕೆ, ನಿಧಿಗಳ ಲಭ್ಯತೆ ಮತ್ತು ಯೋಜನೆಗಳ ಆದ್ಯತೆಗಳ ಆಧಾರದ ಮೇಲೆ ಅರ್ಹ ಮನೆಮಂದಿಗಳಿಗೆ ಕೆಲಸವನ್ನು ಹಂಚುತ್ತಾರೆ. ಸ್ಥಳೀಯ ಅಭಿವೃದ್ಧಿ ಅಗತ್ಯಗಳು ಮತ್ತು ಸಾಧ್ಯತೆಯ ಆಧಾರದ ಮೇಲೆ ಕಾರ್ಯಕ್ಷೇತ್ರ ಮತ್ತು ಕಾರ್ಯಗಳನ್ನು ನಿರ್ಧರಿಸಲಾಗುತ್ತದೆ.",
		raise_new_demand: "ಹೊಸ ಬೇಡಿಕೆಗೆ ಮನವಿ",
		actionplan_proceeding: "ಕ್ರಿಯಾ ಯೋಜನೆ ಪ್ರಕ್ರಿಯೆ",
		actionplan_priority: "ಕ್ರಿಯಾ ಯೋಜನೆ ಆದ್ಯತೆ",
		gp_budget_data: "GP ಬಜೆಟ್ ಡೇಟಾ",
		back_to_raise_new_demand: "ಹೊಸ ಬೇಡಿಕೆಗೆ ಹಿಂದಿರುಗಿ",
		raise_new_demand_with_another_account:
			"ಮತ್ತೊಂದು ಖಾತೆಯೊಂದಿಗೆ ಹೊಸ ಬೇಡಿಕೆಗೆ ಮನವಿ",
		go_to_pending_work_list: "ಬಾಕಿ ಇರುವ ಕೆಲಸದ ಪಟ್ಟಿಗೆ ಹೋಗಿ",
		public_verify_phone_number:
			"ಹೊಸ ಬೇಡಿಕೆಗೆ ಅರ್ಜಿ ಸಲ್ಲಿಸಲು ದಯವಿಟ್ಟು ನಿಮ್ಮ ಫೋನ್ ಸಂಖ್ಯೆಯನ್ನು ಪರಿಶೀಲಿಸಿ",
		demand_request_accepted_message:
			"ನಿಮ್ಮ ವಿನಂತಿಯನ್ನು ಸ್ವೀಕರಿಸಲಾಗಿದೆ. ಗ್ರಾಮ ಪಂಚಾಯತ್ ಪ್ರತಿನಿಧಿಗಳು ಶೀಘ್ರದಲ್ಲೇ ನಿಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸುತ್ತಾರೆ.",
		next_step_choose_work: "ಮುಂದಿನ ಹಂತ (ಕೆಲಸವನ್ನು ಆರಿಸಿ)",
		zilla_panchayat: "ಜಿಲ್ಲಾ ಪಂಚಾಯಿತಿ",
		taluk_panchayat: "ತಾಲೂಕು ಪಂಚಾಯಿತಿ",
		gram_panchayat: "ಗ್ರಾಮ ಪಂಚಾಯಿತಿ",
		village: "ಗ್ರಾಮ",
		full_name: "ಪೂರ್ಣ ಹೆಸರು",
		job_card: "ಜಾಬ್ ಕಾರ್ಡ್",
		remarks: "ಟೀಕೆಗಳು",
		back: "ಹಿಂದೆ",
		select: "ಆಯ್ಕೆ ಮಾಡಿ",
		who_we_are: "ನಾವು ಯಾರು?",
		our_story: "ನಮ್ಮ MGNREGA ಕಥೆ",
		about_description:
			"ಮಹಾತ್ಮ ಗಾಂಧಿ ರಾಷ್ಟ್ರೀಯ ಗ್ರಾಮೀಣ ಉದ್ಯೋಗ ಖಾತರಿ ಯೋಜನೆಯ ಪರಿಣಾಮಕಾರಿ ಅನುಷ್ಠಾನಕ್ಕಾಗಿ 2-4-2008 ರಂದು MGNREGS ನಿರ್ದೇಶನಾಲಯವನ್ನು ಸ್ಥಾಪಿಸಲಾಯಿತು. ಯೋಜನೆಯ ಕಾರ್ಯಾಚರಣಾ ಮಾರ್ಗಸೂಚಿಗಳ ಪ್ರಕಾರ ಯೋಜನೆಯ ಅನುಷ್ಠಾನವನ್ನು ಮೇಲ್ವಿಚಾರಣೆ ಮಾಡಲು 6-8-2013 ರಂದು ಗ್ರಾಮೀಣ ಅಭಿವೃದ್ಧಿ ಆಯುಕ್ತಾಲಯವನ್ನು ರಚಿಸಲಾಯಿತು -2013. ನಿರ್ದೇಶಕರ ಹುದ್ದೆಯನ್ನು 'ಆಯುಕ್ತ, ಗ್ರಾಮೀಣ ಅಭಿವೃದ್ಧಿ' ಗೆ ನವೀಕರಿಸಲಾಯಿತು. ಆಯುಕ್ತಾಲಯವು ಮಹಾತ್ಮ ಗಾಂಧಿ ರಾಷ್ಟ್ರೀಯ ಗ್ರಾಮೀಣ ಉದ್ಯೋಗ ಖಾತರಿ ಯೋಜನೆಯ ಅನುಷ್ಠಾನವನ್ನು ಮೇಲ್ವಿಚಾರಣೆ ಮಾಡುವ ಜವಾಬ್ದಾರಿಯನ್ನು ಹೊಂದಿದೆ ಮತ್ತು ಸರ್ಕಾರದ ಮೂಲಕ ನಿಯೋಜಿಸಲಾದ ಇತರ ಯೋಜನೆಗಳನ್ನು ಹೊಂದಿದೆ. ಪ್ರಸ್ತುತ MGNREGS ಜೊತೆಗೆ, ಶ್ಯಾಮ್ ಪ್ರಸಾದ್ ಮುಖರ್ಜಿ ರರ್ಬನ್ ಮಿಷನ್, ಸಂಸದ್ ಆದರ್ಶ್ ಗ್ರಾಮ ಯೋಜನೆ ಮತ್ತು ಉನ್ನತಿ ಯೋಜನೆಗಳನ್ನು ಆಯುಕ್ತಾಲಯದ ಮೇಲ್ವಿಚಾರಣೆಯಡಿ ಅನುಷ್ಠಾನಗೊಳಿಸಲಾಗುತ್ತಿದೆ. ಆಯುಕ್ತ, ಗ್ರಾಮೀಣ ಅಭಿವೃದ್ಧಿ ಆಯುಕ್ತಾಲಯದ ಮುಖ್ಯಸ್ಥರಾಗಿದ್ದಾರೆ. ಮುಖ್ಯ ಕಾರ್ಯನಿರ್ವಾಹಕ ಅಧಿಕಾರಿ, ನಾಲ್ಕು ಸಂಯುಕ್ತ ನಿರ್ದೇಶಕರು, ಮುಖ್ಯ ಹಣಕಾಸು ಸಲಹೆಗಾರ, ನಾಲ್ಕು ಸಹಾಯಕ ನಿರ್ದೇಶಕರು, ಲೆಕ್ಕಾಧಿಕಾರಿ, ಲೆಕ್ಕಪರಿಶೋಧನಾ ಅಧಿಕಾರಿ ಮತ್ತು ಇತರ ಬೆಂಬಲ ಸಿಬ್ಬಂದಿ ಆಯುಕ್ತರಿಗೆ ಸಹಾಯ ಮಾಡಲು ಕೆಲಸ ಮಾಡುತ್ತಿದ್ದಾರೆ.",
		view_portfolio: "ಪೋರ್ಟ್‌ಫೋಲಿಯೊ ವೀಕ್ಷಿಸಿ",
		portfolio: "ಪೋರ್ಟ್‌ಫೋಲಿಯೊ",
		our_schemes: "ನಮ್ಮ ಯೋಜನೆಗಳು",
		portfolio_description: "ಇಲ್ಲಿ ನಾವು ಕೆಲಸ ಮಾಡುತ್ತಿರುವ ಕೆಲವು ಯೋಜನೆಗಳಿವೆ.",
		amruth_sarovara: "ಅಮೃತ ಸರೋವರ",
		jaljeevan_mission: "ಜಲ ಜೀವನ್ ಮಿಷನ್",
		jal_sanjeevini: "ಜಲ ಸಂಜೀವಿನಿ",
		grey_water_management: "ಬೂದು ನೀರಿನ ನಿರ್ವಹಣೆ",
		convergence_comes_here: "ಇಲ್ಲಿ ಸಮಾಗಮ ಬರುತ್ತದೆ",
		what_is_convergence: "ಸಮಾಗಮವು ವಿವಿಧ ಯೋಜನೆಗಳ ಏಕೀಕರಣವಾಗಿದೆ.",
		get_started: "ಪ್ರಾರಂಭಿಸಿ",
		// translations for Contact.js
		get_in_touch: "ಸಂಪರ್ಕದಲ್ಲಿರಿ!",
		contact_description: "ನಾವು ಸಹಾಯ ಮಾಡಲು ಇಲ್ಲಿ ಇದ್ದೇವೆ.",
		name_placeholder: "ಹೆಸರು :",
		email_placeholder: "ಇಮೇಲ್ :",
		subject_placeholder: "ವಿಷಯ :",
		message_placeholder: "ಸಂದೇಶ :",
		send_message: "ಸಂದೇಶ ಕಳುಹಿಸಿ",
		phone_helpline: "ದೂರವಾಣಿ ಸಹಾಯವಾಣಿ",
		commissioner: "ಆಯುಕ್ತರು",
		email: "ಇಮೇಲ್",
		location: "ಸ್ಥಳ",
		phone_number: "ದೂರವಾಣಿ ಸಂಖ್ಯೆ",
		send_otp: "OTP ಕಳುಹಿಸಿ",
		otp_sent_message:
			"ಮೇಲಿನ ಮೊಬೈಲ್ ಸಂಖ್ಯೆಗೆ ನಾವು ನಿಮಗೆ 6 ಅಂಕಿಗಳ ಕೋಡ್ ಅನ್ನು ಕಳುಹಿಸಿದ್ದೇವೆ. ಸೈನ್ ಇನ್ ಮಾಡಲು ದಯವಿಟ್ಟು ಅದನ್ನು ಇಲ್ಲಿ ನಮೂದಿಸಿ.",
		otp_sent_again_message:
			"OTP ಅನ್ನು ನಿಮ್ಮ ಫೋನ್ ಸಂಖ್ಯೆಗೆ ಮರುಕಳುಹಿಸಲಾಗಿದೆ. ದಯವಿಟ್ಟು ಅದನ್ನು ಮತ್ತೆ ಕೆಳಗೆ ನಮೂದಿಸಿ",
		resend_otp: "OTP ಅನ್ನು ಮರುಕಳುಹಿಸಿ",
		otp_expires_in: "OTP ಅವಧಿ ಮುಗಿಯುತ್ತದೆ",
		submit: "ಸಲ್ಲಿಸಿ",
		home: "ಮುಖ್ಯ ಪುಟ",
		about_us: "ನಮ್ಮ ಬಗ್ಗೆ",
		services: "ಸೇವೆಗಳು",
		contact_us: "ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ",
		sign_in: "ಸೈನ್ ಇನ್ ಮಾಡಿ",
		for: "ಫಾರ್",
		days_to: "ದಿನಗಳು",
		individual: "ವ್ಯಕ್ತಿಗಳಿಗೆ",
		community: "ಸಮುದಾಯಕ್ಕೆ",
		want_a_job: "ಕಾಮಗಾರಿ ಬೇಡಿಕೆ",
		banner_title: "100 ದಿನಗಳ ಕಾಲ ಸುಧಾರಿತ ಆಲೋಚನೆಗಳನ್ನು ನೀಡುವುದು: ",
		banner_desc:
			"ಪ್ರತಿ ಮನೆಗೆ ಆರ್ಥಿಕ ವರ್ಷದಲ್ಲಿ ಕೂಲಿ ಉದ್ಯೋಗ. MGNREGA ಅಂತರ್ಗತ ಬೆಳವಣಿಗೆಯನ್ನು ಉತ್ತೇಜಿಸುವಲ್ಲಿ ನಿರ್ಣಾಯಕ ಪಾತ್ರವನ್ನು ವಹಿಸುತ್ತದೆ, ಗ್ರಾಮೀಣ ಸಂಕಷ್ಟವನ್ನು ಕಡಿಮೆ ಮಾಡುತ್ತದೆ ಮತ್ತು ಭಾರತದಲ್ಲಿ ಸುಸ್ಥಿರ ಗ್ರಾಮೀಣ ಜೀವನೋಪಾಯವನ್ನು ನಿರ್ಮಿಸುತ್ತದೆ. ದಿನದ ಕೂಲಿ 349 ರೂ",
		raise_request: "Raise request",
		recent_work_history: "ಇತ್ತೀಚಿನ ಕೆಲಸದ ಇತಿಹಾಸ",
		work_type: "ಕೆಲಸದ ಪ್ರಕಾರ",
		work_code: "ಕೆಲಸದ ಕೋಡ್",
		wage: "ಕೂಲಿ",
		material: "ವಸ್ತು",
		demand_sucsess: "ಬೇಡಿಕೆಯನ್ನು ಯಶಸ್ವಿಯಾಗಿ ಹೆಚ್ಚಿಸಲಾಗಿದೆ",
		work_demand_code: "ಕೆಲಸದ ಬೇಡಿಕೆ ಕೋಡ್",
		work_title: "ಕೆಲಸದ ಶೀರ್ಷಿಕೆ",
		category_title: "ವರ್ಗ ಶೀರ್ಷಿಕೆ",
		description_label: "ವಿವರಣೆ",
		simplified_work_category: "ಸರಳೀಕೃತ ಕೆಲಸದ ವರ್ಗ",
		work_sub_type_1: "ಕೆಲಸದ ಉಪ ಪ್ರಕಾರ I",
		work_sub_type_2: "ಕೆಲಸದ ಉಪ ಪ್ರಕಾರ II",
		work_sub_type_3: "ಕೆಲಸದ ಉಪ ಪ್ರಕಾರ III",
		work_sub_type_4: "ಕೆಲಸದ ಉಪ ಪ್ರಕಾರ IV",
	},
};

const changeLanguage = (languageCode) => {
	localStorage.setItem("language", languageCode);
	window.location.reload();
};

const getCurrentLanguage = () => {
	return localStorage.getItem("language") || "en";
};

export { translations, changeLanguage, getCurrentLanguage };
